import styled from 'styled-components';
import { NavLink as ReactNavLink } from 'react-router-dom';
import Offcanvas from 'react-bootstrap/Offcanvas';

export const NavbarContainer = styled.div`
  width: 100%;
  position: fixed;
  z-index: 99;
  top: 0;
  height: 64px;
  background-color: ${(props) => props.theme.color.bg.secondary};
  padding: 3px 50px;

  display: grid;

  /* Out/2026 (pedido do Bruno): logo à esquerda e o resto alinhado à direita —
     da direita para a esquerda: foto, nome, sino, importar conta de luz,
     plano e bandeiras. Antes 1fr 6fr 1fr espalhava os itens pela barra. */
  grid-template-columns: auto 1fr auto;
  column-gap: 28px;

  @media only screen and (max-width: 950px) {
    grid-template-columns: 1fr 6fr 1fr;
    column-gap: 0;
    padding: 3px 2vw;
    background-color: ${(props) => props.theme.color.bg.muted};
    /* grid-template-columns: repeat(3, 1fr); */
  }

  @media print {
    display: none;
  }
`;

export const MobileMenuOption = styled.div`
  display: none;

  @media only screen and (max-width: 950px) {
    display: flex;

    justify-content: start;
    align-items: center;

    svg {
      color: ${(props) => props.theme.color.ui.shade4};
      font-size: 28px;
    }
  }
`;

export const LogoContainer = styled.div`
  align-self: center;

  img {
    width: 114px;
    height: auto;
    cursor: pointer;
  }

  @media only screen and (max-width: 950px) {
    justify-self: center;
  }
`;

export const MiddleContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 32px;
  min-width: 0;

  @media only screen and (max-width: 1280px) {
    gap: 20px;
  }
`;

// Links do desktop saíram da barra em out/2026 (menu lateral); o NavLink fica
// como base do MenuLink do menu do celular
export const NavLink = styled(ReactNavLink)`
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.regular};
  font-weight: ${(props) => props.theme.font.body.weight.regular};
  line-height: ${(props) => props.theme.font.body.lineHeight.regular};
  color: ${(props) => props.theme.color.text.inverse};
  padding: 0 10px;
  text-decoration: none;
  margin: 0;
  line-height: 0;
  &:hover {
    cursor: pointer;
    background: rgba(0, 0, 0, 0.1);
    color: #e6e6e6;
    border-radius: 3px;
  }
  &.active {
    font-weight: ${(props) => props.theme.font.body.weight.bold};
  }
`;

export const ActionContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media only screen and (max-width: 950px) {
    display: none;
  }
`;

export const DropdownContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media only screen and (max-width: 950px) {
    display: none;
  }
`;

export const MobileUploadContainer = styled.div`
  display: none;

  @media only screen and (max-width: 950px) {
    display: flex;
    align-self: center;
    justify-content: flex-end;

    svg {
      font-size: 20px;
      color: #333;
    }
  }
`;

export const Menu = styled(Offcanvas)`
  max-width: 80%;
  background-color: ${(props) => props.theme.color.bg.primary};
  padding: 0 20px;
`;

export const MenuHeader = styled(Offcanvas.Header)`
  height: 64px;
  padding: 0;
  h2 {
    margin: 0;
    color: ${(props) => props.theme.color.text.disabled};
  }
`;

export const MenuBody = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MenuLink = styled(NavLink)`
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${(props) => props.theme.color.text.primary};

  &.active {
    font-weight: ${(props) => props.theme.font.body.weight.bold};
  }
`;

export const MenuFooter = styled.div`
  /* height: 30px; */
  border-top: 1px solid ${(props) => props.theme.color.ui.shade2};
  padding: 10px 0;
`;

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  height: 30px;
  gap: 10px;

  svg,
  span {
    color: ${(props) => props.theme.color.text.danger};
  }
`;
